export const load = () => ({
	title: 'Storm Windows vs Replacement Windows',
	showTitle: true,
});
